import { getBoardClienteExibicao } from '../utils/clienteBoardDisplay';
import { getOrderTipoOSLetter } from './tipoOsFilterUtils';

export function collectTechnicianOrders(technicianGroups, previsaoFilter = []) {
  const allOrders = [];
  Object.values(technicianGroups || {}).forEach((groups) => {
    Object.keys(groups).forEach((groupName) => {
      if (
        previsaoFilter.length > 0 &&
        groupName !== 'Em deslocamento' &&
        groupName !== 'Em serviço'
      ) {
        if (!previsaoFilter.includes(groupName)) return;
      }
      allOrders.push(...(groups[groupName] || []));
    });
  });
  return allOrders;
}

export function computeTechnicianFilterCounts(technicianOrders, technicianGroups) {
  const cityData = {};
  technicianOrders.forEach((ordem) => {
    const cidade = ordem.TB02115_CIDADE || ordem.cidade || 'Não informado';
    const estado = ordem.TB02115_ESTADO || ordem.estado || '';
    if (!cityData[cidade]) cityData[cidade] = { count: 0, estado };
    cityData[cidade].count += 1;
  });
  const citiesWithCounts = Object.entries(cityData)
    .filter(([, v]) => v.count > 0)
    .map(([cidade, { count, estado }]) => ({ cidade, count, estado: estado || '' }))
    .sort((a, b) => b.count - a.count);

  const bairroAcc = {};
  technicianOrders.forEach((ordem) => {
    const bairro = ordem.TB02115_BAIRRO || ordem.bairro || 'Não informado';
    bairroAcc[bairro] = (bairroAcc[bairro] || 0) + 1;
  });
  const bairrosWithCounts = Object.keys(bairroAcc)
    .map((bairro) => ({ bairro, count: bairroAcc[bairro] }))
    .filter((item) => item.count > 0)
    .sort((a, b) => b.count - a.count);

  const clienteAcc = {};
  technicianOrders.forEach((ordem) => {
    const cliente = getBoardClienteExibicao(ordem) || ordem.cliente || ordem.TB01008_NOME || 'Não informado';
    clienteAcc[cliente] = (clienteAcc[cliente] || 0) + 1;
  });
  const clientesWithCounts = Object.keys(clienteAcc)
    .map((cliente) => ({ cliente, count: clienteAcc[cliente] }))
    .filter((item) => item.count > 0)
    .sort((a, b) => b.count - a.count);

  const tipoAcc = {};
  technicianOrders.forEach((ordem) => {
    const tipo = getOrderTipoOSLetter(ordem);
    tipoAcc[tipo] = (tipoAcc[tipo] || 0) + 1;
  });
  const tiposOSWithCounts = Object.keys(tipoAcc)
    .map((tipo) => ({ tipo, count: tipoAcc[tipo] }))
    .filter((item) => item.count > 0)
    .sort((a, b) => b.count - a.count);

  const slaAcc = {};
  technicianOrders.forEach((ordem) => {
    const sla = ordem.sla || 'Em dia';
    slaAcc[sla] = (slaAcc[sla] || 0) + 1;
  });
  const slasWithCounts = Object.keys(slaAcc)
    .map((sla) => ({ sla, count: slaAcc[sla] }))
    .filter((item) => item.count > 0)
    .sort((a, b) => b.count - a.count);

  const equipAcc = {};
  technicianOrders.forEach((ordem) => {
    const equipamento = ordem.equipamento || ordem.TB01010_RESUMIDO || ordem.TB01010_NOME || '';
    if (equipamento) equipAcc[equipamento] = (equipAcc[equipamento] || 0) + 1;
  });
  const equipamentosWithCounts = Object.keys(equipAcc)
    .map((equipamento) => ({ equipamento, count: equipAcc[equipamento] }))
    .filter((item) => item.count > 0)
    .sort((a, b) => b.count - a.count);

  const buildDefeito = (key) => {
    const acc = {};
    technicianOrders.forEach((ordem) => {
      const v = String(ordem[key] ?? '').trim();
      if (!v) return;
      acc[v] = (acc[v] || 0) + 1;
    });
    return Object.entries(acc)
      .map(([value, count]) => ({ value, count }))
      .sort((a, b) => a.value.localeCompare(b.value));
  };

  const previsaoData = {
    'Previsto para hoje': 0,
    'Previstas para amanhã': 0,
    FUTURA: 0,
  };
  Object.values(technicianGroups || {}).forEach((groups) => {
    if (groups['Previsto para hoje']) previsaoData['Previsto para hoje'] += groups['Previsto para hoje'].length;
    if (groups['Previstas para amanhã']) previsaoData['Previstas para amanhã'] += groups['Previstas para amanhã'].length;
    if (groups.FUTURA) previsaoData.FUTURA += groups.FUTURA.length;
  });
  const previsaoWithCounts = Object.keys(previsaoData)
    .filter((key) => previsaoData[key] > 0)
    .map((previsao) => ({ previsao, count: previsaoData[previsao] }))
    .sort((a, b) => b.count - a.count);

  return {
    citiesWithCounts,
    bairrosWithCounts,
    clientesWithCounts,
    tiposOSWithCounts,
    slasWithCounts,
    equipamentosWithCounts,
    previsaoWithCounts,
    defeitoDescricaoWithCounts: buildDefeito('defeito_descricao'),
    defeitoAlertWithCounts: buildDefeito('defeito_alert'),
    defeitoClassificationWithCounts: buildDefeito('defeito_classification'),
    defeitoSeverityWithCounts: buildDefeito('defeito_severity_level'),
  };
}
